import { render } from "./ChangeStatusButton.vue?vue&type=template&id=2e8116b6"
import script from "./ChangeStatusButton.vue?vue&type=script&lang=js"
export * from "./ChangeStatusButton.vue?vue&type=script&lang=js"
script.render = render

export default script